import { render, staticRenderFns } from "./site-details.vue?vue&type=template&id=c5055aa0&"
import script from "./site-details.vue?vue&type=script&lang=js&"
export * from "./site-details.vue?vue&type=script&lang=js&"
import style0 from "./site-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports